import classnames from 'classnames';
import LocalizedNoIndexLink from 'components/LocalizedNoIndexLink';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const CSS = require('./FilterButton.less');

interface FilterButtonProps {
  name: string;
  isActive: boolean;
  text: string;
}

function getModalRoute(filterName, location) {
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('modal', filterName);
  return { ...location, search: searchParams.toString() };
}

function FilterButton({
  name,
  isActive,
  text,
  location,
}: FilterButtonProps & RouteComponentProps) {
  const destination = getModalRoute(name, location);
  return (
    <LocalizedNoIndexLink
      to={destination}
      className={classnames(CSS.Button, { [CSS.ButtonActive]: isActive })}
    >
      {text}
    </LocalizedNoIndexLink>
  );
}

export default withRouter(FilterButton);
